import { Hyperlink as HyperlinkType } from 'modules/config/state/config-types'
import React from 'react'
import styled from '@emotion/styled'

const StyledHyperlink = styled.a<{ color: string }>`
  color: ${(props) => props.color};
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  font-size: 0.85em;
  &:hover {
    text-decoration: underline;
  }
`

export const Hyperlink = ({
  isEnabled,
  url,
  text,
  textColor = 'white',
  styles = {},
}: HyperlinkType & { textColor?: string; styles?: object }) => {
  if (!isEnabled || !url || !text) {
    return null
  }

  return (
    <StyledHyperlink
      data-id="embedded-external-link"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      color={textColor}
      style={{
        ...styles,
      }}
    >
      {text}
    </StyledHyperlink>
  )
}
